<template>
  <div class="atendimento-container">

    <div v-if="!isMobile || hasPersonDetails && isMobile && chatVisible && !detailView" class="d-block d-md-none">
      <NxDraggableButton :onClick="backToConversations" :iconClass="'fas fa-arrow-left'"
        :buttonPosition="buttonPosition" :draggable="false" />
    </div>

    <div v-if="!isMobile || hasPersonDetails && isMobile && chatVisible && !detailView" class="d-block d-md-none">
      <NxDraggableButton :onClick="toggleDetailView" :iconClass="'fas fa-info-circle'"
        :buttonPosition="buttonConversationPosition" :draggable="false" />
    </div>

    <div v-if="!isMobile || hasPersonDetails && isMobile && detailView" class="d-block d-md-none">
      <NxDraggableButton :onClick="backToChat" :iconClass="'fas fa-comments'"
        :buttonPosition="buttonConversationPosition" :draggable="false" />
    </div>

    <div class="atendimento d-flex flex-wrap">
      <Conversations ref="conversations" v-show="!isMobile || (isMobile && !chatVisible)"
        class="atendimento-conversations" :isLoading="isLoadingConversations" :conversations="conversations"
        :selectedConversationId="selectedConversationId" @selectConversation="handleSelectConversation"
        @changeTab="handleTabChange" @createNewConversation="handleNewConversation"
        @readConversation="handleReadConversation" />

      <Chat ref="chat" class="atendimento-chat" v-show="!isMobile || (chatVisible && !detailView)"
        v-if="hasPersonDetails" :style="hasPersonDetails" :isLoading="isLoadingMessages"
        :selectedConversationId="selectedConversationId" :messages="messages" @sendChatMessage="handleSendChatMessage"
        @sendBot="sendControllerBot" @sendUpdateOperator="updateBot" />

      <Detail v-show="!isMobile || (detailView)" class="atendimento-detail" :isLoading="isLoadingPerson"
        :person="personDetails" :currentConversation="conversation" @sendUpdateOperator="updataOperator"
        @sendUpdateStatus="updateStatus" />
    </div>

  </div>
</template>

<script>
import Conversations from './components/conversations/Conversations.vue'
import Chat from './components/chat/Chat.vue'
import Detail from './components/details/Details.vue'
// import { JWTService } from '@/shared/services/jwt'

import _ from 'lodash'

import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import AccountMixin from '@/store/module/account/mixin'
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import NxDraggableButton from '@/components/nexum/components/buttons/NxDraggableButton.vue'

export default {
  name: 'Atendimento',
  components: {
    Conversations,
    Chat,
    defaultbutton,
    NxDraggableButton,
    Detail
  },
  mixins: [AccountMixin],
  computed: {
    hasPersonDetails () {
      return this.personDetails !== null
    },
    selectedConversationId () {
      return this.conversation.conversationId
    },
    isMobile () {
      return window.innerWidth < 768
    }
  },
  data () {
    return {
      isLoadingConversations: false,
      conversationsSubscription: null,
      conversations: [],

      conversationSubscription: null,
      conversationDispatchesSubscription: null,
      conversation: {
        conversationId: null,
        identifier: null,
        provider: null
      },

      buttonPosition: {
        top: 7,
        left: 8
      },

      buttonConversationPosition: {
        top: 7,
        left: 80
      },

      isLoadingMessages: false,
      messages: [],
      isLoadingPerson: false,
      chatVisible: false,
      detailView: false,
      personDetails: null,
      stompClient: null,
      isLoading: false,
      isConnected: false
    }
  },

  watch: {
    'conversation.conversationId': {
      deep: true,
      async handler (value) {
        if (!this.conversation.identifier) return

        await Promise.all([
          this.getPersonDetails(value, this.conversation.formattedPhone),
          this.getMessages(value)
        ])

        this.subscribeToConversation(value)
        this.subscribeToConversationDispatches(value)
      }
    },
    messages () {
      this.handleReadConversation(this.conversation.conversationId)
    }
  },
  mounted () {
    this.convertWindow()
    this.$nextTick(() => {
      if (this.$route.params.newConversation) {
        this.startNewConversation(this.$route.params.newConversation)
        this.$route.params.newConversation = null
      }
    })

    this.connect()
  },
  beforeDestroy () {
    this.unsubscribeFromConversations()
    this.unsubscribeFromConversation()
    this.unsubscribeFromConversationDispatches()
    this.disconnect()
  },
  methods: {
    convertWindow () {
      if (this.isMobile) {
        this.buttonPosition = {
          top: 9,
          left: 8
        }
        this.buttonConversationPosition = {
          top: 9,
          left: 78
        }
      }
    },
    // WebSocket methods (StompJS)
    connect () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, frame => {
        this.isConnected = true
        this.subscribeToConversations()
        this.getConversations()
      }, error => {
        this.isConnected = false
        console.error('Connection error: ' + error)
      })
    },
    disconnect () {
      if (this.stompClient !== null) {
        this.stompClient.disconnect()
      }
    },
    subscribeToConversations () {
      if (this.isConnected) {
        const topic = '/topic/conversations'

        this.conversationsSubscription = this.stompClient.subscribe(topic, this.onConversationsUpdated)
      }
    },
    unsubscribeFromConversations () {
      if (this.conversationsSubscription !== null) {
        this.conversationsSubscription.unsubscribe()
        this.conversationsSubscription = null
      }
    },
    handleReadConversation (conversation) {
      const payload = {
        conversationId: conversation,
        _id: this.account.id
      }
      if (conversation === this.conversation.conversationId) {
        this.getConversations()
      }
      console.log(`payload`)
      console.log(payload)
      this.stompClient.send(`/app/conversations/readMessage`, {}, JSON.stringify(payload))
    },
    subscribeToConversation (conversationId) {
      if (this.isConnected) {
        this.unsubscribeFromConversation()
        const topic = `/topic/messages/${conversationId}`

        this.conversationSubscription = this.stompClient.subscribe(topic, this.onMessageReceived)
      }
    },
    unsubscribeFromConversation () {
      if (this.conversationSubscription !== null) {
        this.conversationSubscription.unsubscribe()
        this.conversationSubscription = null
      }
    },
    subscribeToConversationDispatches (conversationId) {
      if (this.isConnected) {
        this.unsubscribeFromConversationDispatches()
        const topic = `/topic/dispatches/${conversationId}`

        this.conversationDispatchesSubscription = this.stompClient.subscribe(topic, this.onMessageDispatched)
      }
    },
    unsubscribeFromConversationDispatches () {
      if (this.conversationDispatchesSubscription !== null) {
        this.conversationDispatchesSubscription.unsubscribe()
        this.conversationDispatchesSubscription = null
      }
    },
    // WebSocket Message handlers
    onConversationsUpdated () {
      this.getConversations()
    },
    onMessageReceived (content) {
      const message = JSON.parse(content.body)

      this.messages.push({
        ...message,
        sent: true,
        order: this.messages.length
      })

      this.$refs.chat.scrollToBottom()
    },
    onMessageDispatched (content) {
      const message = JSON.parse(content.body)

      const messageIndex = this.messages.findIndex(m => m.id === message.temporaryId)
      const hasMessage = messageIndex !== -1

      if (hasMessage) {
        const sentMessage = this.messages[messageIndex]

        sentMessage.id = message.id
        sentMessage.sent = true
      }
    },
    sendChatMessage (payload) {
      const { conversationId } = payload
      this.stompClient.send(`/app/conversations/${conversationId}/messages`, {}, JSON.stringify(payload))
    },
    sendControllerBot (payload) {
      payload.conversationId = this.conversation.conversationId
      this.stompClient.send(`/app/conversations/controllerBot`, {}, JSON.stringify(payload))
    },
    updateBot (payload) {
      payload.conversationId = this.conversation.conversationId
      payload.identifier = this.conversation.identifier
      payload.name = this.conversation.name
      payload.provider = this.conversation.provider
      payload.protocol = this.conversation.protocol
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    updataOperator (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    updateStatus (payload) {
      this.stompClient.send(`/app/conversations/updateStatus`, {}, JSON.stringify(payload))
      this.refreshPage()
    },
    refreshPage () {
      location.reload()
    },
    createConversation (payload) {
      this.stompClient.send(`/app/conversations/createConversation`, {}, JSON.stringify(payload))
      this.onConversationsUpdated()
    },
    // Interaction methods
    handleSelectConversation (conversation) {
      if (this.isLoading) return

      this.conversation = conversation
      this.chatVisible = true
      this.detailView = false
      this.getMessages(conversation.conversationId)
      this.getPersonDetails(conversation.conversationId, this.conversation.formattedPhone)
    },
    handleTabChange () {
      this.conversations = []
      this.getConversations()
    },
    handleSendChatMessage (message) {
      const temporaryId = Math.floor(Date.now() / 1000).toString() + this.messages.length.toString()
      const id = this.account.id

      const payload = {
        conversationId: this.conversation.conversationId,
        identifier: this.conversation.identifier,
        message: message.message,
        temporaryId,
        type: message.type,
        operatorId: id,
        name: (this.account.pessoa.nome).replace('\t', ''),
        provider: this.conversation.provider
      }

      message.id = temporaryId
      this.messages.push(message)
      this.sendChatMessage(payload)
    },
    handleSendChatBase64 (message) {
      const temporaryId = Math.floor(Date.now() / 1000).toString() + this.messages.length.toString()

      const payload = {
        conversationId: this.conversation.conversationId,
        identifier: this.conversation.identifier,
        message: message.message,
        temporaryId,
        type: message.type
      }

      message.id = temporaryId
      this.messages.push(message)
      this.sendChatMessage(payload)
    },
    // API methods
    async getConversations () {
      if (this.isLoadingConversations) return

      const requestConfig = {
        params: {
          status: 'Aberto',
          // status: this.$refs.conversations.tabs.active,
          operatorId: this.account.id,
          deptoId: null
        }
      }

      if (Array.isArray(this.conversations) && this.conversations.length === 0) {
        this.isLoadingConversations = true
      }

      await AtendimentoRepository.GetConversations(requestConfig)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.conversations = data
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          if (this.isLoadingConversations) {
            this.isLoadingConversations = false
          }
        })
    },
    async getPersonDetails (conversationId, phone) {
      if (this.conversation.conversationId === null) {
        this.personDetails = null
        return
      }

      this.isLoadingPerson = true

      await AtendimentoRepository.GetPersonDetails(conversationId, { params: { phone } })
        .then(response => {
          const { status, data } = response

          if (status === 200 && !_.isNil(data) && !_.isEmpty(data)) {
            this.personDetails = data
          } else {
            this.personDetails = null
          }
        })
        .catch(error => {
          console.error(error)
          this.personDetails = null
        })
        .finally(() => {
          this.isLoadingPerson = false
        })
    },
    async getMessages (conversationId) {
      if (conversationId !== null) {
        this.isLoadingMessages = true

        await AtendimentoRepository.GetConversationMessages(conversationId)
          .then(response => {
            const { data } = response
            let messages = []

            if (data && data.length > 0) {
              messages = data
                .map((message, index) => {
                  return {
                    ...message,
                    sent: true,
                    order: index
                  }
                })
            }
            if (conversationId === this.conversation.conversationId) {
              this.messages = messages
              this.$refs.chat.scrollToBottom()
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            this.isLoadingMessages = false
          })
      }
    },
    handleNewConversation (newConversation) {
      this.handleSelectConversation(newConversation)
    },
    handleConversationStarted (conversationId) {
      this.conversationId = conversationId
    },
    toggleExpand () {
      this.expanded = !this.expanded
    },
    backToConversations () {
      this.chatVisible = false
      this.detailView = false
    },
    backToChat () {
      this.chatVisible = true
      this.detailView = false
    },
    toggleDetailView () {
      if (this.detailView) {
        this.detailView = false
      } else {
        this.detailView = true
        this.chatVisible = false
      }
    },

    updateButtonPosition (newPosition) {
      this.buttonPosition = newPosition
    }
  }
}
</script>

<style lang="scss" scoped>
.atendimento-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.atendimento {
  display: flex;
  flex-direction: row;
  min-height: 100%;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #0BACA0 transparent;
  position: relative;
}

.atendimento-detail,
.atendimento-conversations {
  flex: 1;
  min-width: 200px;
  min-height: 250px;
}

@media (max-width: 768px) {
  .atendimento {
    flex-direction: column;
  }

  .atendimento-chat {
    order: 3;
  }

  .atendimento-detail {
    order: 2;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    background: white;
    overflow: auto;
  }

  .atendimento-conversations {
    order: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/atendimento.vue